import React from 'react';
import Container from 'components/Layout/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import NewsletterForm from 'components/Form/NewsletterForm';
import Box from '@mui/material/Box';
import SocialList from './SocialList';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

interface FooterProps {}

const useStyles = makeStyles(
  (theme: Theme) => ({
    footer: {
      '& a:hover': {
        color: theme.palette.primary.main,
      },
    },
  }),
  { name: 'Footer' },
);

const Footer: React.FC<FooterProps> = () => {
  const classes = useStyles();

  return (
    <Box id="footer" component="footer" sx={{ pb: { xs: 0.5, sm: 2.25 }, bgcolor: 'secondary.dark', mt: 0 }}>
      <Container className={classes.footer}>
        <Grid
          sx={{
            pt: {
              xs: 4,
              sm: 6,
            },
            pb: {
              xs: 2,
              sm: 3,
            },
          }}
          container
          spacing={2}
          justifyContent="flex-end"
        >
          <Stack component={Grid} item xs={12} sm={3} md={3} lg={2} spacing={1}>
            <Typography variant="h6" gutterBottom>
              Shop
            </Typography>
            <Link to="/cards/all" color="text.secondary" component={RouterLink}>
              Shop Gift Cards
            </Link>
            <Link to="/redeem" color="text.secondary" component={RouterLink}>
              Redeem a card
            </Link>
            <Link to="/landing/corporate" color="text.secondary" component={RouterLink}>
              Card.Gift Business
            </Link>
          </Stack>
          <Stack component={Grid} item xs={12} sm={3} md={3} lg={2} spacing={1}>
            <Typography variant="h6" gutterBottom>
              About Card.Gift
            </Typography>
            <Link to="/page/about-us" color="text.secondary" component={RouterLink}>
              About Us
            </Link>
          </Stack>
          <Stack component={Grid} item xs={12} sm={3} md={3} lg={2} spacing={1}>
            <Typography variant="h6" gutterBottom>
              Legals
            </Typography>
            <Link to="/page/terms-of-service" color="text.secondary" component={RouterLink}>
              Terms of Service
            </Link>
            <Link to="/page/privacy-policy" color="text.secondary" component={RouterLink}>
              Privacy Policy
            </Link>
          </Stack>
          <Stack component={Grid} item xs={12} sm={3} md={3} lg={2} spacing={1}>
            <Typography variant="h6" gutterBottom>
              Support
            </Typography>
            <Link to="/page/contact-us" color="text.secondary" component={RouterLink}>
              Contact Us
            </Link>
          </Stack>
          <Grid
            item
            sx={{
              display: {
                xs: 'none',
                md: 'flex',
                lg: 'none',
              },
            }}
            md={6}
          />
          <Stack
            sx={{
              order: {
                xs: -1, // Move to top for 'xs'
                sm: 0,
              },
            }}
            component={Grid}
            item
            xs={12}
            sm={9}
            md={6}
            lg={4}
            spacing={1}
          >
            <Typography variant="h6" gutterBottom>
              Subscribe to our newsletter
            </Typography>
            <Box style={{ marginTop: 0 }}>
              <NewsletterForm />
            </Box>
          </Stack>
          <Grid
            item
            sx={{
              display: {
                xs: 'none',
                md: 'flex',
                lg: 'none',
              },
            }}
            md={6}
          />
          <Stack component={Grid} item xs={12} sm={9} md={6} lg={4} spacing={1}>
            <Typography variant="h6">Get to know us...</Typography>
            <SocialList />
          </Stack>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
